import { Database } from '../../adapters/database'
import { DexieDbUtils } from '../../utils/libs/dexieDbUtils'
const DBUtils = DexieDbUtils

class AppDataRepo {
  constructor(dbInstance) {
    this.dbInstance = dbInstance
  }

  static async getDb() {
    let isClient = false
    try {
      if (window) isClient = true
    } catch (error) {
      console.log(error)
    }
    if (!isClient) return null
    let db = self.repositories?.appDataRepo
    if (!db) {
      db = await AppDataRepo.init()
      self.repositories.appDataRepo = db
    }
    return db
  }

  static async init() {
    const db = new Database()
    await db.init(DBUtils, 'appData', { index: 'content' })
    if (!db) return null
    return new AppDataRepo(db)
  }

  async get(contentId) {
    const data = await this.dbInstance.findOne({ content: contentId })
    return data
  }

  async save(data) {
    await this.dbInstance.save(data)
  }

  async clean() {
    await this.dbInstance.deleteAll()
  }
}

export { AppDataRepo }
